import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { FormattedMessage } from 'react-intl';
import messages from 'aurora-translations';
import { Avatar, Box, Typography, Grid } from '@material-ui/core';
import TenantProfile from 'aurora-images/user_profileV3.svg';
import isEmpty from 'lodash/isEmpty';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import style from './style';
const OwnerShareDetail = ({ classes, owners, contractDetails, Headtitle }) => {
  const { lang } = useSelector(
    createSelector(
      state => state.language,
      language => ({
        lang: language.locale,
      }),
    ),
  );
  const ownerDetail =
    contractDetails?.propertyDetails?.isSharedMortgage &&
    owners?.length !== contractDetails?.propertyDetails?.customerIds?.length
      ? owners?.filter(id => id?.customerId === contractDetails?.propertyDetails?.customerIds?.[0])
      : owners;

  return (
    !isEmpty(ownerDetail) && (
      <Box className={(classes.paperCardFrame, classes.marginBottom)}>
        <div className={classes.titleHead}>
          <div className={classes.title}>
            <span>
              <FormattedMessage {...messages.mortgage_shares} />
            </span>
          </div>
        </div>

        {ownerDetail?.length > 0 &&
          ownerDetail?.map((owner, index) => {
            return (
              <div className={classes.container}>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    {' '}
                    <Box
                      sx={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(2, 1fr)',
                        '@media (max-width: 600px)': {
                          gridTemplateColumns: 'repeat(1, 1fr)',
                        },
                      }}
                      item
                      xs={12}
                      className={classes.ownerDetailHolder}
                    >
                      <Box item>
                        <Grid container spacing={1}>
                          <Grid item>
                            <Avatar alt='Fawwaz Saqr Raad' src={TenantProfile} className={classes.ownerAvatarimg} />
                          </Grid>
                          <Grid item>
                            <Typography variant='subtitle1'>
                              {Headtitle === 'buyers' ? (
                                <FormattedMessage {...messages.buyer} />
                              ) : (
                                <FormattedMessage {...messages.OWNER} />
                              )}
                              # {index + 1}
                            </Typography>
                            <Typography variant='subtitle1' className={classes.strongText}>
                              {lang === 'en' ? owner?.ownerNameEn : owner?.ownerNameAr}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Box>

                      <Box item>
                        <Typography variant='subtitle1'>
                          <FormattedMessage {...messages.property_share} />
                        </Typography>
                        <Typography variant='body1' className={classes.strongText}>
                          {owner?.ownerShare || owner?.share} %
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </div>
            );
          })}
      </Box>
    )
  );
};
OwnerShareDetail.propTypes = {
  classes: PropTypes.object.isRequired,
  application: PropTypes.object.isRequired,
  contractDetails: PropTypes.object.isRequired,
  Headtitle: PropTypes.string.isRequired,
  owners: PropTypes.object.isRequired,
};

export default withStyles(style)(OwnerShareDetail);
